import { memo } from 'react';
import { Link } from 'react-router-dom';
import { LogOut, User } from 'lucide-react';
import { AttributionQuotaIndicator } from './AttributionQuotaIndicator';
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTriggerWithFix,
} from '../ui/navigation-menu';
import { Button } from '../ui/button';

type UserMenuProps = {
  user: {
    firstName: string;
  } | null;
  onLogoutClick: (e: React.MouseEvent) => void;
};

export const UserMenu = memo<UserMenuProps>(({ user, onLogoutClick }) => {
  if (!user) {
    return (
      <div className="hidden gap-x-3 lg:flex">
        <Button variant="outline" asChild>
          <Link to="/login">Log In</Link>
        </Button>
        <Button variant="outline" asChild>
          <a
            href="https://www.elementus.io/schedule"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact
          </a>
        </Button>

        <Button variant="default" asChild>
          <Link to="/register">Sign Up</Link>
        </Button>
      </div>
    );
  }

  return (
    <NavigationMenu className="mr-1 hidden lg:flex" viewport={false}>
      <NavigationMenuList>
        {/* Attribution Quota Indicator now fetches its own data */}
        <AttributionQuotaIndicator />
        <NavigationMenuItem>
          <NavigationMenuTriggerWithFix>
            {user.firstName}
          </NavigationMenuTriggerWithFix>
          <NavigationMenuContent>
            <div>
              <NavigationMenuLink asChild>
                <Link
                  to="/account"
                  className="flex w-full flex-row items-center text-muted-foreground hover:bg-accent"
                >
                  <User className="h-4 w-4" />
                  Account
                </Link>
              </NavigationMenuLink>
              <NavigationMenuLink asChild>
                <button
                  onClick={onLogoutClick}
                  className="flex w-full flex-row items-center text-muted-foreground hover:bg-accent"
                >
                  <LogOut className="h-4 w-4" />
                  Logout
                </button>
              </NavigationMenuLink>
            </div>
          </NavigationMenuContent>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
});

UserMenu.displayName = 'UserMenu';
